import PaginationContainer from "components/PaginationContainer";

const SyslogServerPagination = (props) => {
  const {
    originSyslogServerList,
    selectedPage,
    setSelectedPage,
    setSelectedPageLimit
  } = props;

  return (
    <div>
      <PaginationContainer
        total={originSyslogServerList.length}
        onPageChange={setSelectedPage}
        isCurrentPageId={selectedPage}
        onEntryLimitChange={currentPageNum => {
          setSelectedPageLimit(currentPageNum);
          setSelectedPage(1);
        }}
      />
    </div>
  );
}

export default SyslogServerPagination;

